import React,{useEffect, useState} from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Tabmenu from '../tabmenu/Tabmenu';
import { getConsumerDetail, updateProfile, uploadAvatar } from '../../lib/api';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '../ui/alertDialog';
import { useStore } from '../../store';
import Cookies from "js-cookie";
export default function CheckSymptoms() {
  
  let navigate = useNavigate();
  const reset = useStore((state) => state.reset)
  const selectedPatient = useStore((state) => state.patient);
  const setPatient = useStore(state => state.setPatient)
  const [date, setDate] = useState(new Date());
  const [imagechange, setimagechange] = useState('Change');
  const [updating, setupdating] = useState('');
  const [dataset,setDataset] = useState([]);
  const [isKiosk,setKiosk] = useState(false)
  const [editable,setEditable] = useState(false)
  const [file, setFile] = useState(null);
  const [first_name,setFirstName] =useState('')
  const [middle_name,setmiddle_name] =useState('')
  const [location,setlocation] =useState('')
  const [email,setemail] =useState('')
  const [dob,setdob] =useState(null)
  const [age,setage] =useState(null);
  const [showLogoutConfirm,setShowLogoutConfirm] = useState(false)
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    console.log(e.target.files[0])
    uploadpick(e.target.files[0])
  };
  const uploadpick= async (file) => {
    setimagechange('Loading')
    if(file!="") {
      const formData = new FormData();
      formData.append('file', file);
        const data = await uploadAvatar(formData);
        if(data?.message=="successfully completed"){
          console.log(data.data.result.profile_url);
          let dataset = {
            "profile_picture": data.data.result.profile_url
          } 
          updatProfile(dataset)
        }
    }
  } 
  const updatedetails= async () => {
    let dataset = {
      "name": first_name,
      "dob": dob, 
      "location":location,
      "age":age
    } 
    let emailold ='';
    let olddata = selectedPatient
    {olddata?.contact?.map((cont,j)=>{
      if(cont.type=='email') {emailold=cont.value} 
      console.log(cont.value)    
    })}
    console.log(emailold+'---'+email)
    if(emailold=='') {
      dataset = {...dataset,
        "email": {
          "old_email": { },
          "new_email": {
              "value": email,
              "category": "primary",
              "type": "email", 
              "is_verified": false
          }
      }
    }
    } else if(emailold!=email) {
      dataset = {...dataset, 
        "email": {
          "old_email": {
              "value": emailold,
              "category": "primary",
              "type": "email",
              "is_verified": false
          },
          "new_email": {
              "value": email,
              "category": "primary",
              "type": "email", 
              "is_verified": false
          }
      }
    }
  }
  
    updatProfile(dataset)
  }
  const updatProfile= async (dataset) => {
    
    setupdating('Please wait, processing.')
    const id = selectedPatient?.id;
    const data = await updateProfile(id,dataset);
    if(data.message=="successfully completed") {
      setupdating('')
      fetchPatient() 
    }
    fetchPatient() 
  }
  const fetchPatient = async () => {
    const id = selectedPatient?.id;
      const data = await getConsumerDetail(id);
      console.log(data.data);
      console.log(data?.data?.result?.consumer_details?.id);
      console.log('patiant data get');
      if(data?.data?.result?.consumer_details) {
        setPatient({...data?.data?.result?.consumer_details})
              // sessionStorage.setItem('patientdata',JSON.stringify({...data?.data?.result?.consumer_details}));
              setDataset({...data?.data?.result?.consumer_details});
      }
      setimagechange('Change')
  }
  const setvalues = async (data) => {
    {data?.contact?.map((cont,j)=>{
      if(cont.type=='email') {setemail(cont.value)}     
    })}
    setFirstName(data?.profile?.first_name+' '+data?.profile?.middle_name+' '+data?.profile?.last_name)
    setlocation(data?.source?.location)
    setdob(data?.dob)
    setage(data?.age) 
    setmiddle_name(data?.profile?.middle_name);
  }
  const handleDateChange = (date, dateString) => {
    setdob(dateString);
  };
  const calculateAge = (dateOfBirth) => {
    setdob(dateOfBirth)
    const dob = new Date(dateOfBirth);
    const currentDate = new Date();
    
    let age = currentDate.getFullYear() - dob.getFullYear();
    const monthDifference = currentDate.getMonth() - dob.getMonth();
    
    if (monthDifference < 0 || (monthDifference === 0 && currentDate.getDate() < dob.getDate())) {
      age--;
    }
    
    setage(age)
  }
  useEffect(()=>{
    setDataset(selectedPatient);
    setvalues(selectedPatient)
    setKiosk(JSON.parse(sessionStorage.getItem('isKiosk')));
    // console.log(dataset)
    
  }, [ ]);
  const onLogout = () => {
    setShowLogoutConfirm(true)
  }
const logout = () => {
  console.log('logout')
  Cookies.remove("consumerAccessToken");
 Cookies.remove("consumerRefreshToken");
  localStorage.removeItem("patientId");

  sessionStorage.removeItem("patientdata");
  sessionStorage.removeItem("isKiosk");
  sessionStorage.removeItem("patientPhone");
  sessionStorage.removeItem("currentVitals")
  sessionStorage.removeItem("currentEcg")
  sessionStorage.removeItem("locations")
  sessionStorage.removeItem("specialities")
  sessionStorage.removeItem('selectedAppointment')
  reset()
  navigate("/");
}
  return (
    <>
      <div className=" bg-gray-50 min-h-screen">
        <div className='flex text-black p-4 pt-6 h-16 fixed max-w  z-50 w-full bg-gray-50 '>
          <div>
          <Link to="/Dashboard">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="w-6 h-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
            </svg>
            </Link>
          </div>
          <div className='pl-2 flex-1 mt-0.5'>
            <h4 className='font-semibold text-sm'>Settings {date.toString}</h4>
          </div> 
        </div>
        <div className='h-14'></div>
        <div className=' p-4 pt-20 '>
          <div className='flex'>
            <div className='mb-5 relative w-24'>
              {/* {isKiosk? */}
                  {dataset?.profile?.avatar_url? 
                    <img src={dataset?.profile?.avatar_url} className=" mx-2 rounded-full object-cover h-20 w-20"/> 
                  :
                    <img src="../../../images/user.svg" className=" mx-2 rounded-full object-cover h-20 w-20"/>}
                {/* :
                  dataset?.imgUrl? 
                    <img src={dataset?.image} className=" mx-2 rounded-full object-cover h-20 w-20"/> 
                    :
                    <img src="../../../images/user.svg" className=" mx-2 rounded-full object-cover h-20 w-20"/>
                } */}
                
               {editable&&<>
                <div className='absolute top-0 text-center w-full h-full pt-6 bg-white bg-opacity-60'>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" class="w-8 h-8 mx-auto">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6.827 6.175A2.31 2.31 0 015.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 00-1.134-.175 2.31 2.31 0 01-1.64-1.055l-.822-1.316a2.192 2.192 0 00-1.736-1.039 48.774 48.774 0 00-5.232 0 2.192 2.192 0 00-1.736 1.039l-.821 1.316z" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 12.75a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM18.75 10.5h.008v.008h-.008V10.5z" />
                  </svg>
                </div>
               <input type="file" className='absolute top-0 w-24 h-12 p-6 opacity-0' onChange={handleFileChange}/>
               </>  }
            </div>
            <div className='pl-4 pt-1'>
              <div className='text-lg font-semibold text-blue-900'>
                  {/* {isKiosk? */}
                      {dataset?.profile?.first_name? dataset?.profile?.first_name+' '+ middle_name+' '+dataset?.profile?.last_name : '' }
                    {/* :
                      dataset?.firstName? dataset?.firstName+' '+dataset?.middleName+' '+dataset?.lastName: 'Janet Wills' 
                  } */}
              </div>
              { dob && <p className=''>DOB : {dob}</p>} 
              {age&& <p className=''>Age : {age}</p>}
              <button className='bg-blue-900 text-white px-2 py-1 rounded-lg mt-2 text-sm' onClick={()=>setEditable(!editable)}>Edit</button>
            </div>
          </div>
          {editable==true?   <> 
            <div className='flex flex-col'>
                <lable>Full name</lable>
                {/* {isKiosk? */}
                <>
                  <div className='grid grid-cols-1 gap-2'>
                    <input type="text" value={first_name} placeholder="First name" className='p-2 bg-white shadow border rounded-lg ' onChange={(e)=>setFirstName(e.target.value)}/>
                  </div>
                </>
              {/* :
                <>
                  <div className='flex'>
                    <input type="text" value={dataset?.first_name} placeholder="First name" className='p-2 bg-white shadow border rounded-lg flex-1'  onChange={(e)=>setFirstName(e.target.value)}/>
                  </div>
                </>
              }  */}
            </div>
            <div className='flex flex-col mt-5 relative'>
                <lable>Date of birth</lable>
                <input type="date" onChange={(e)=>calculateAge(e.target.value)} value={dob} className='p-2 bg-white shadow border rounded-lg'/>
              
            </div>
           <div className='flex flex-col mt-5'>
                <lable className="capitalize">Age</lable>
                <input type="number" value={age} placeholder="" className='p-2 bg-white shadow border rounded-lg'  onChange={(e)=>setage(e.target.value)}/>
            </div>
            <div className='flex flex-col mt-5'>
                <lable className="capitalize">Email</lable>
                <input type="email" value={email} placeholder="example@email.com" className='p-2 bg-white shadow border rounded-lg'  onChange={(e)=>setemail(e.target.value)}/>
            </div>
            <div className='flex flex-col mt-5'>
                <lable className="capitalize">Location</lable>
                <input type="text" value={location} placeholder="Location Name" className='p-2 bg-white shadow border rounded-lg'   onChange={(e)=>setlocation(e.target.value)}/>
            </div>
            {updating!=''&& <div className='p-2 text-white font-bold absolute top-1/2 z-30 w-full text-center bg-blue-900 bg-opacity-90 left-0'>{updating}</div>}
            <button onClick={()=>updatedetails()} className='text-white bg-blue-900 p-2 px-4 mt-4 font-bold rounded-full'>Update</button>

          </> :<>

            <div className='text-lg bg-blue-100 p-4 rounded-xl border border-blue-400 mt-1'>
              Email : {email? email: 'Not set'}
            </div>
            <div className='text-lg bg-blue-100 p-4 rounded-xl border border-blue-400 mt-2'>
             Phone :{dataset?.contact?.length>0&& <>
                    {dataset?.contact.map((cont,j)=>(
                        cont.type=='phone'&& <> {cont.value}</> 
                    ))}
              
              </>  }
            </div>
            <div className='text-lg bg-green-100 p-4 rounded-xl border border-green-400 mt-2'>    
              Location : <span className='capitalize'>{location}</span>
            </div>
            <div>
              <button className='text-white bg-blue-900 p-2 px-4 mt-4 font-bold rounded-full' onClick={()=>onLogout()}>Log Out</button>
            </div>
          </>}   
        </div>
      </div>
      <div>
      <AlertDialog open={showLogoutConfirm} onOpenChange={setShowLogoutConfirm}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Log Out</AlertDialogTitle>
          <AlertDialogDescription>
          Are you sure you want to log out?.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={logout}>Yes</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
    </div>



      
      <Tabmenu />
    </>
  );
}